var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "route-options" },
    [
      _c("h6", { staticClass: "title" }, [
        _vm._v("\n        Travel via\n    "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.value.via, function (route, index) {
        return [
          _c(
            "div",
            { key: "via-route-" + index, staticClass: "route" },
            [
              _c("StationPicker", {
                attrs: { "start-value": route.station.name },
                on: {
                  pick: function (name) {
                    route.station = name
                    _vm.updateModel()
                  },
                  emptied: function () {
                    route.station = _vm.blankRoute().station
                    _vm.updateModel()
                  },
                },
              }),
              _vm._v(" "),
              _c("radio-selectors", {
                attrs: { options: _vm.config.options.method.via },
                model: {
                  value: route.method,
                  callback: function ($$v) {
                    _vm.$set(route, "method", $$v)
                  },
                  expression: "route.method",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          route.method[0] === "C"
            ? _c(
                "div",
                { key: "via-route-time-" + index, staticClass: "extra-mins" },
                [
                  _c("label", [
                    _vm._v("\n                extra mins\n                "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: route.extra,
                          expression: "route.extra",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: { value: route.extra },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(route, "extra", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c("h6", { staticClass: "title mt-2" }, [
        _vm._v("\n        Avoid\n    "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.value.avoid, function (route, index) {
        return [
          _c(
            "div",
            { key: "avoid-route-" + index, staticClass: "route" },
            [
              _c("StationPicker", {
                attrs: { "start-value": route.station.name },
                on: {
                  pick: function (name) {
                    route.station = name
                    _vm.updateModel()
                  },
                  emptied: function () {
                    route.station = _vm.blankRoute().station
                    _vm.updateModel()
                  },
                },
              }),
              _vm._v(" "),
              _c("radio-selectors", {
                attrs: { options: _vm.config.options.method.avoid },
                model: {
                  value: route.method,
                  callback: function ($$v) {
                    _vm.$set(route, "method", $$v)
                  },
                  expression: "route.method",
                },
              }),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }